import { List, Toast } from "antd-mobile";
import axios from "axios";
import React, {
  useContext,
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import PsContext from "../../context";
import { momentDate, queryParam, upperCase, useQuery } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import { Button, Form, Col } from "react-bootstrap";

const DayOrderDates = forwardRef((props, ref) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [dataList, setDataList] = useState([]);

  const params = useParams();
  let searchParams = queryParam(useQuery());

  useEffect(() => {
    loadDayOrders();
  }, [props.attendance_date, props.category_id, props.floor_id]);

  const loadDayOrders = () => {
    context.setLoader(true);
    const form = new FormData();
    form.append("attendance_date", searchParams?.attendance_date);
    form.append("category", searchParams?.category);
    form.append("acyear", searchParams?.acyear);
    form.append("floor_id", searchParams?.floor_id);
    axios.post(ServiceUrl.MOB.LIST_HOSTEL_ATTENDANCE_DAY, form).then((res) => {
      if (res["data"].status == "1") {
        let m = res["data"].data;
        setDataList(m);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }

      context.setLoader(false);
    });
  };

  const getTitle = () => {
    return params?.type
      ? `${upperCase(params.type)} Attendance Marked Report`
      : "Attendance Marked Report";
  };

  const bakcLinkClick = () => {
    let path = searchParams?.attendance_date
      ? searchParams?.from
        ? "/staff/app/hostel-attendance?from=marked"
        : "/staff/app/hostel-attendance"
      : "/staff/app";
    navigate(path);
  };

  const markedCount = (ltype) => {
    let m = dataList.filter((item) => item.leave_type == ltype);
    return m.length;
  };

  const linkClick = (toUrl, val) => {
    navigate(toUrl + "?category=" + val);
  };

  return (
    <>
      <Header
        onBack={(e) => bakcLinkClick()}
        title={
          getTitle() + "- " + searchParams?.attendance_date
          //momentDate(dataList[0].attendance_date, "DD/MMM/YYYY")
        }
        backAction={true}
        rightActions={[]}
      />

      <section className="top-space pt-0 pb-0">
        <List>
          {dataList.map((item) => (
            <List.Item
              extra={
                <span
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    backgroundColor:
                      item.leave_type == "a" || item.leave_type == "la"
                        ? "e74c3c"
                        : "",
                  }}
                >
                  {upperCase(item.leave_type)}
                </span>
              }
              className={
                item.leave_type == "a" || item.leave_type == "la"
                  ? "bg-red-50 text-danger"
                  : item.leave_type == "od"
                  ? "bg-blue-50 text-info"
                  : item.leave_type == "l"
                  ? "bg-silver-200 text-dark"
                  : null
              }
            >
              {item.name} {item.initial || ""}
              <br />
              {item.registerno || item.admissionno}
            </List.Item>
          ))}
        </List>
      </section>
      <div className="footer-nav-area pt-2 px-3">
        <div className="suha-footer-nav " style={{ height: "42px" }}>
          <div className="row">
            <div className="col-8">
              <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                <span className="border-bottom text-danger">AB</span> :
                <span className="text-danger">{markedCount("a")}</span>
              </Button>

              <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                <span className="border-bottom text-primary">LWP</span>:
                <span className="text-primary">{markedCount("lwp")}</span>
              </Button>
              <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                <span className="border-bottom text-dark">L</span>:
                <span className="text-dark ">{markedCount("l")}</span>
              </Button>
              <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                <span className="border-bottom text-success">P</span>:
                <span className="text-success ">{markedCount("p")}</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});
export default DayOrderDates;
